import React from 'react';
import BraftEditor from 'braft-editor'
import { ContentUtils } from 'braft-utils';
import 'braft-editor/dist/index.css'
import BarftMediaDialog from "../BsyDashRichText/BarftMediaDialog"
import BarftLinkDialog from "../BsyDashRichText/BarftLinkDialog"
import BsyDialog from '../../BsyDialog';
import "./index.css"
import { BsyUtils } from "../../../utils/Utils";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import classNames from 'classnames';
class BsyDashRichTextConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editorState: props.richText ? BraftEditor.createEditorState(props.richText.html) : BraftEditor.createEditorState(null),
            // editorState:BraftEditor.createEditorState(null, {
            //     // 禁用自动添加空段落
            //     blockRenderMap: Map({
            //       'atomic': {
            //         element: 'figure'
            //       }
            //     })
            //   }),
            isError: false,
            value: '',
            errorLength: 0
        };
        this.editorInstance = ""
        this.editorRef = React.createRef();
        this.mediaDialog = React.createRef();
        this.linkDialog = React.createRef();
        this.hooks = {


        }
        this.controls = [
            'font-size', 'text-color', 'bold', 'italic', 'underline', 'text-align',
            {
                key: 'my-modal',
                type: 'modal',
                title: '图片', // 指定鼠标悬停提示文案
                className: 'my-modal', // 指定触发按钮的样式名
                html: '<i></i>', // 指定在按钮中渲染的html字符串
                text: '图片', // 指定按钮文字，此处可传入jsx，若已指定html，则text不会显示    
                onClick: () => { }, // 指定触发按钮点击后的回调函数
                modal: {
                    id: 'media', // 必选属性，传入一个唯一字符串即可
                    title: '添加图片', // 指定弹窗组件的顶部标题
                    className: 'media', // 指定弹窗组件样式名
                    width: 620, // 指定弹窗组件的宽度
                    height: 398, // 指定弹窗组件的高度
                    showFooter: true, // 指定是否显示弹窗组件底栏
                    showCancel: true, // 指定是否显示取消按钮
                    showConfirm: true, // 指定是否显示确认按钮
                    confirmable: true, // 指定确认按钮是否可用
                    showClose: true, // 指定是否显示右上角关闭按钮
                    closeOnBlur: true, // 指定是否在点击蒙层后关闭弹窗(v2.1.24)
                    closeOnConfirm: true, // 指定是否在点击确认按钮后关闭弹窗(v2.1.26)
                    closeOnCancel: true, // 指定是否在点击取消按钮后关闭弹窗(v2.1.26)
                    cancelText: '取消', // 指定取消按钮文字
                    confirmText: '确定', // 指定确认按钮文字
                    bottomText: null, // 指定弹窗组件底栏左侧的文字，可传入jsx
                    onConfirm: () => { this.saveToMediaEditor() }, // 指定点击确认按钮后的回调函数
                    onCancel: () => { }, // 指定点击取消按钮后的回调函数
                    onClose: () => { }, // 指定弹窗被关闭后的回调函数
                    onBlur: () => { }, // 指定蒙层被点击时的回调函数
                    children: <BarftMediaDialog ref={this.mediaDialog} />

                }
            },
            {
                key: 'my-link',
                type: 'modal',
                title: '链接', // 指定鼠标悬停提示文案
                className: 'my-modal', // 指定触发按钮的样式名
                html: '<i></i>', // 指定在按钮中渲染的html字符串
                text: '链接', // 指定按钮文字，此处可传入jsx，若已指定html，则text不会显示    
                onClick: () => {
                    BsyDialog({
                        title: "链接",
                        customCls: "rich-cinfog-link-dailog",
                        width: 500,
                        height: 320,
                        noFooter: true,
                        okText: React.language("ok"),
                        cancelText: React.language("cancel"),
                        onOk: () => {
                            return false
                        },
                        onContentCreate: () => {
                            return <BarftLinkDialog ref={this.linkDialog} emitRichLinkConfig={this.saveTolinkEditor} />
                        },
                    });
                }, // 指定触发按钮点击后的回调函数
                // modal: {
                //     id: 'link', // 必选属性，传入一个唯一字符串即可
                //     title: '链接', // 指定弹窗组件的顶部标题
                //     className: 'link', // 指定弹窗组件样式名
                //     width: 500, // 指定弹窗组件的宽度
                //     height: 330, // 指定弹窗组件的高度
                //     showFooter: true, // 指定是否显示弹窗组件底栏
                //     showCancel: true, // 指定是否显示取消按钮
                //     showConfirm: true, // 指定是否显示确认按钮
                //     confirmable: true, // 指定确认按钮是否可用
                //     showClose: true, // 指定是否显示右上角关闭按钮
                //     closeOnBlur: true, // 指定是否在点击蒙层后关闭弹窗(v2.1.24)
                //     closeOnConfirm: false, // 指定是否在点击确认按钮后关闭弹窗(v2.1.26)
                //     closeOnCancel: true, // 指定是否在点击取消按钮后关闭弹窗(v2.1.26)
                //     cancelText: '取消', // 指定取消按钮文字
                //     confirmText: '确定', // 指定确认按钮文字
                //     bottomText: null, // 指定弹窗组件底栏左侧的文字，可传入jsx
                //     onConfirm: (ev) => { this.saveTolinkEditor(ev) }, // 指定点击确认按钮后的回调函数
                //     onCancel: () => { }, // 指定点击取消按钮后的回调函数
                //     onClose: () => { }, // 指定弹窗被关闭后的回调函数
                //     onBlur: () => { }, // 指定蒙层被点击时的回调函数
                //     children: <BarftLinkDialog ref={this.linkDialog} />
                // }
            },
            'link'
        ]

    }
    componentDidMount() {
        const editorInstance = this.editorRef.current.getDraftInstance(); // 获取BraftEditor实例
        editorInstance && editorInstance.focus(); // 获取焦点
        window.$('.rich-text-page-config .bf-controlbar').find('.control-item').eq(11).find('i').attr('class', 'icon-bsy-iconquxiaolianjie')
        window.$('.rich-text-page-config .bf-controlbar').find('button').eq(12).find('i').attr('class', 'icon-link')
        window.$('.rich-text-page-config .bf-controlbar').find('button').eq(11).attr('data-title', '图片').find('i').attr('class', 'icon-bsy-pic5')
        window.$('.rich-text-page-config .bf-controlbar').find('button').eq(9).find('i').attr('class', 'icon-bsy-iconyouduiqi')
        window.$('.rich-text-page-config .bf-controlbar').find('button').eq(8).find('i').attr('class', 'icon-bsy-iconjuzhongduiqi')
        window.$('.rich-text-page-config .bf-controlbar').find('button').eq(7).find('i').attr('class', 'icon-align-left')
        window.$('.rich-text-page-config .bf-controlbar').find('button').eq(6).find('i').attr('class', 'icon-bsy-iconxiahuaxian')
        window.$('.rich-text-page-config .bf-controlbar').find('button').eq(5).find('i').attr('class', 'icon-bsy-iconxieti')
        window.$('.rich-text-page-config .bf-controlbar').find('button').eq(4).find('i').attr('class', ' icon-bsy-iconcuti')
        window.$('.rich-text-page-config .bf-controlbar').find('.control-item').eq(1).find('i').attr('class', 'icon-bsy-iconxiguangongju')
        window.$('.rich-text-page-config .bf-controlbar').find('.control-item').eq(12).find('i').attr('class', 'icon-unlink')

    }
    saveToMediaEditor = () => {
        console.log(333,this.mediaDialog.current.state.carouselMapFlies)
        if (this.mediaDialog.current.state.activeType === "img" && this.mediaDialog.current.state.carouselMapFlies.length >= 1) {
            let list = []
            this.mediaDialog.current.state.carouselMapFlies.forEach(element => {
                list.push({
                    type: 'IMAGE',
                    url: element.previewUrl ||  BsyUtils.getfiledownloadURL(element, {})
                })
            });
            this.handleEditorChange(ContentUtils.insertMedias(this.state.editorState, list))
            
        }
        if (this.mediaDialog.current.state.activeType === "link" && this.mediaDialog.current.state.linkType) {
            this.handleEditorChange(ContentUtils.insertMedias(this.state.editorState, [{ type: 'IMAGE', url: this.mediaDialog.current.linkTitle }]))
        }
    }
    saveTolinkEditor = (ev) => {


        const state = this.linkDialog.current.state
        const isTttp = (state.linkText.indexOf('https://') >= 0 || state.linkText.indexOf('http://') >= 0)
        if (state.eidtModelOpenLink) {
            let html = '<a href=' + (isTttp ? state.linkText : 'http://' + state.linkText) + ' target="_blank">' + state.titleText + '</a>'
            this.handleEditorChange(ContentUtils.insertHTML(this.state.editorState, html))
        }
        if (!state.eidtModelOpenLink) {
            let html = '<a href=' + (isTttp ? state.linkText : 'http://' + state.linkText) + '>' + state.titleText + '</a>'
            this.handleEditorChange(ContentUtils.insertHTML(this.state.editorState, html))
        }

    }
    checkFn = () => {

        if (this.state.editorState.toHTML().length >= 10000) {
            return false
        } else {
            return true
        }
    }
    focusEditor() {
    }
    onChange = (v) => {
    }
    handleEditorChange = (editorState) => {
        if (editorState.toHTML().length >= 10000) {
            tipAlert({
                type: "warning",
                msg: '超出10000字数限制，无法继续输入',
            });
            return false
        }
        this.setState({
            editorState,
            errorLength: editorState.toHTML().length,
            isError: editorState.toHTML().length >= 8000 ? true : false
        })
    }
    saveEidtData = () => {

    }

    myUploadFn = (param) => {
        const formData = new FormData();
        formData.append("file", param.file);
        formData.append(
            "x:uploader",
            window.FX.STATIC.user ? window.FX.STATIC.user._id : ""
        );
        React.axios("/dashboard/upload_workbenches_img", formData)
            .then((res) => {
                param.success({
                    // url: res.data.file.previewUrl,
                    url: BsyUtils.getfiledownloadURL(res.data.file, {}),
                    meta: {
                        id: res.data.file.qnKey,
                        title: "",
                        alt: "",
                        loop: false, // 指定音视频是否循环播放
                        autoPlay: false, // 指定音视频是否自动播放
                        controls: false, // 指定音视频是否显示控制栏
                        poster: '', // 指定视频播放器的封面
                    }
                })
            })
            .catch((err) => {
                tipAlert({
                    type: "warning",
                    msg: err,
                });
            })
            .finally(() => { });

    }

    render() {
        const { editorState } = this.state
        return <div className={'rich-text-page-config ' + this.props.mode}>
            {this.state.isError && <div className={classNames('tip ' + (this.state.errorLength >= 8000 ? "waring " : ' ') + (this.state.errorLength >= 10000 ? "error" : ''))}><span>{this.state.errorLength}</span><span>/10000</span></div>}
            {
                this.props.mode === "edit" && <BraftEditor
                    ref={this.editorRef}
                    stripPastedStyles
                    value={editorState}
                    hooks={this.hooks}
                    placeholder=''
                    imageControls={['float-left', 'float-right', 'align-left', 'align-center', 'align-right', 'size', 'remove']}
                    onChange={this.handleEditorChange}
                    controls={this.controls}
                ></BraftEditor>
            }
        </div>;
    }
}
export default BsyDashRichTextConfig;